import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { EdgeCamera } from '../../../cameras/camera.model';
import { createReducer, on } from '@ngrx/store';
import { CameraActions } from '@states/camera/camera.action-types';
import { SnapshotEntry } from '../../../development/thumbnails.service';

export interface CameraSnapshotState extends EntityState<EdgeCamera.CameraSnapshotItem> {
  loading: boolean;
  loaded: boolean;
}

export const adapter = createEntityAdapter<EdgeCamera.CameraSnapshotItem>({
  selectId: (snapshot: EdgeCamera.CameraSnapshotItem) => snapshot.cameraId,
});

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

export const initialCameraSnapshotState: CameraSnapshotState = adapter.getInitialState({
  loading: false,
  loaded: false,
});

export const cameraSnapshotReducer = createReducer(
  initialCameraSnapshotState,
  on(CameraActions.GetLocationEdgesCamerasSnapshots, (state) => ({
    ...state,
    loading: true,
  })),
  on(CameraActions.GetLocationEdgesCamerasSnapshotsSuccess, (state, action) => {
    const snapshots: EdgeCamera.CameraSnapshotItem[] = action.payload.map((snapshot: SnapshotEntry) => {
      return {
        cameraId: snapshot.cameraId,
        edgeId: snapshot.edgeId,
        snapshot: `snapshot/${snapshot.edgeId}/${snapshot.cameraId}/${snapshot.thumbnail}`,
        snapShotTs: snapshot.timestamp,
        fallbackSnapshot: snapshot.fallbackThumbnail
          ? `snapshot/${snapshot.edgeId}/${snapshot.cameraId}/${snapshot.fallbackThumbnail}`
          : undefined,
        shouldUseFallback: false,
      };
    });
    return {
      ...adapter.upsertMany(snapshots, state),
      loading: false,
      loaded: true,
    };
  }),
  on(CameraActions.GetLocationEdgesCamerasSnapshotsFail, (state) => ({
    ...state,
    loading: false,
    loaded: true,
  })),
  on(CameraActions.SetCameraSnapshotUseFallback, (state, action) => {
    const existing = state.entities[action.cameraId];
    if (!existing?.fallbackSnapshot || existing.shouldUseFallback) {
      return state;
    }
    return adapter.updateOne({
      id: action.cameraId,
      changes: { shouldUseFallback: true },
    }, state);
  }),
  on(CameraActions.SetCameraSnapshotManually, (state, action) => {
    const url = action.url;
    const cameraId = action.cameraId;
    const edgeId = action.edgeId;
    const snapShotTs = action.snapShotTs;

    const cameraEntity: EdgeCamera.CameraSnapshotItem = {
      cameraId: cameraId,
      snapshot: url,
      edgeId: edgeId,
      snapShotTs: snapShotTs,
      shouldUseFallback: false,
    };

    return adapter.upsertOne(cameraEntity, state);
  }),
)
